import React from 'react'
import { motion } from 'framer-motion'
import { useTheme } from '@/hooks/useTheme'

export interface AverageDiscountChartData {
  filledPercentage?: number // Percentage of left segment to fill (0-100), default: ~66%
}

interface AverageDiscountChartProps {
  data?: AverageDiscountChartData
  className?: string
}

const AverageDiscountChart: React.FC<AverageDiscountChartProps> = ({ 
  className = ''
}) => {
  const { theme } = useTheme()

  return (
    <div className={`relative w-full max-w-[214px] h-[100px] overflow-hidden ${className}`}>
      {/* Figma 1:1: left gradient segment 93x44 at y=44 */}
      <motion.div
        initial={{ width: 0, opacity: 0 }}
        animate={{ width: '93px', opacity: 1 }}
        transition={{
          duration: 0.6,
          delay: 0,
          ease: [0.16, 1, 0.3, 1]
        }}
        className="absolute left-0 top-[44px] w-[93px] h-[44px] overflow-hidden"
        style={{ 
          background: 'linear-gradient(to right, rgba(244,254,192,0.24) 0%, #e3fd5a 100%)',
        }}
      />
      
      {/* Figma 1:1: gray block 13x44 at y=44, x=93 */}
      <motion.div
        initial={{ width: 0, opacity: 0 }}
        animate={{ width: '13px', opacity: 1 }}
        transition={{
          duration: 0.4,
          delay: 0.2,
          ease: [0.16, 1, 0.3, 1]
        }}
        className="absolute left-[93px] top-[44px] w-[13px] h-[44px] bg-neutral-200 dark:bg-[#bfbcbc]"
      />
      
      {/* Figma 1:1: divider 2x76 at y=12, x=106 */}
      <motion.div
        initial={{ height: 0, opacity: 0 }}
        animate={{ height: '76px', opacity: 1 }}
        transition={{
          duration: 0.5,
          delay: 0.3,
          ease: [0.16, 1, 0.3, 1]
        }}
        className="absolute left-[106px] top-[12px] w-[2px] h-[76px] bg-[#2d2923] dark:bg-[#fdfdfd]"
      />
      
      {/* Figma 1:1: dashed segment starts at x=108, y=68, width=106 */}
      <motion.div
        initial={{ width: 0, opacity: 0 }}
        animate={{ width: '106px', opacity: 1 }}
        transition={{
          duration: 0.6,
          delay: 0.4,
          ease: [0.16, 1, 0.3, 1]
        }}
        className="absolute left-[108px] top-[68px] w-[106px] h-5"
        style={{ 
          background: `repeating-linear-gradient(90deg, transparent, transparent 2px, ${theme === 'dark' ? '#606060' : 'rgba(45,41,35,0.32)'} 2px, ${theme === 'dark' ? '#606060' : 'rgba(45,41,35,0.32)'} 4px)`
        }}
      />
    </div>
  )
}

export default AverageDiscountChart
